module.exports = __webpack_public_path__ + "static/snowball-testimonials-1-eef416bffe565b1ded0db1fcc79e505b.jpg";